<template>
  <form class="validate-form" @submit.prevent="handleChangePassword">
    <h2 class="intro-x font-bold text-2xl xl:text-3xl text-center xl:text-left">
      {{ $t('public.forgotenPassword') }}
    </h2>
    <div class="intro-x mt-8">
      <div class="mt-6">
        <label
          for="password"
          class="form-label w-full flex flex-col sm:flex-row"
        >
          {{ $t('common.password') }}
        </label>
        <input
          id="password"
          v-model.trim="validate.password.$model"
          type="password"
          name="password"
          class="
          intro-x
          login__input
          form-control
          py-3
          px-4
          border-gray-300
          block
          mt-4
                "
          :class="{ 'border-theme-6': validate.password.$error }"
        />
        <template v-if="validate.password.$error">
          <div
            v-for="(error, index) in validate.password.$errors"
            :key="index"
            class="text-theme-6 mt-2"
          >
            {{ $t(error.$message) }}
          </div>
        </template>
      </div>
      <div class="intro-x mt-5 xl:mt-8 text-center xl:text-left">
        <button
          class="btn btn-primary py-3 px-4 w-full xl:w-32 xl:mr-3 align-top"
          type="submit"
          v-if="!loading"
        >
          {{ $t('public.changePassword') }}
        </button>
        <div
          class="col-span-6 sm:col-span-3 xl:col-span-2 flex flex-col justify-end items-center"
          v-if="loading"
        >
          <LoadingIcon icon="three-dots" class="w-8 h-8" />
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { defineComponent, toRefs, reactive, ref } from 'vue'
import { required, helpers, minLength } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'

export default defineComponent({
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn
    }
  },
  created() {
    if (this.loggedIn) {
      this.$router.push('/')
    }
  },
  methods: {
    handleChangePassword(data) {
      this.loading = true

      const request = {
        userUuid: this.$route.params.userUUID,
        resetPasswordToken: this.$route.params.token,
        password: data.target.elements.password.value
      }

      console.log(request)

      this.$store.dispatch('auth/forgotPasswordProcess', request).then(
        () => {
          this.$router.push('/')
        },
        error => {
          this.loading = false
          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString()
        }
      )
    }
  },
  setup() {
    const loading = ref(false)
    const formData = reactive({
      email: '',
      password: ''
    })
    const rules = {
      password: {
        required: helpers.withMessage(
          'form.validation.requiredField',
          required
        ),
        minLength: helpers.withMessage('form.validation.gte6ch', minLength(6))
      }
    }
    const validate = useVuelidate(rules, toRefs(formData))

    return {
      loading,
      validate,
      formData
    }
  }
})
</script>
